var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagForFlagBulgariaSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    className: "iconify iconify--twemoji",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EEE",
    d: "M32 5H4a4 4 0 0 0-4 4v5h36V9a4 4 0 0 0-4-4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D62612",
    d: "M0 27a4 4 0 0 0 4 4h28a4 4 0 0 0 4-4v-5H0v5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#00966E",
    d: "M0 14h36v8H0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagForFlagBulgariaSvgrepoCom);
export default __webpack_public_path__ + "static/media/flag-for-flag-bulgaria-svgrepo-com.e262f536a9e03a0f73f056cef6dad9b1.svg";
export { ForwardRef as ReactComponent };